import { render, staticRenderFns } from "./Emails.vue?vue&type=template&id=db200ada&scoped=true"
import script from "./Emails.vue?vue&type=script&lang=js"
export * from "./Emails.vue?vue&type=script&lang=js"
import style0 from "./Emails.vue?vue&type=style&index=0&id=db200ada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db200ada",
  null
  
)

export default component.exports